/**
 * Erreur GraphQL renvoyée par le serveur (`errors[0]` de la réponse) : garde `extensions.code`
 * (ex. `BAD_REQUEST`) pour qu'un appelant distingue un refus métier, dont le message est destiné à
 * l'utilisateur, d'une panne. Reste une `Error` au même message : les appelants existants ne voient
 * aucune différence.
 */
export class GraphQLResponseError extends Error {
  readonly code: string | undefined;

  constructor(message: string, code?: string) {
    super(message);
    this.name = 'GraphQLResponseError';
    this.code = code;
  }
}
